<template>
  <!-- {{ purchased_from_this_pool }} - {{ pool_count_allowed }} -
  {{ min_blocked_amount }} -->

  <div class="container" v-if="show_buttons">
    <div v-if="force_rerender">
      <div
        class="row p-1 border rounded border-primary d-flex align-items-center"
        v-if="sorted_bids.length"
      >
        <div class="col">
          <LogoLarge :path="getPath(last_bid.team_id)"></LogoLarge>
        </div>
        <div class="col">
          <TeamName :team_id="last_bid.team_id"></TeamName>
        </div>
        <div class="col">
          {{ formatToIndianCurrency(last_bid.amount) }}
        </div>
        <div class="col">
          <i
            class="bi bi-chevron-double-down float-end"
            v-if="!expand_bids"
            @click="toggleExpandBids()"
          ></i>
          <i
            class="bi bi-chevron-double-up text-danger float-end"
            v-else
            @click="toggleExpandBids()"
          ></i>
        </div>
      </div>
    </div>
    <div class="row" v-if="!sorted_bids.length">
      <div class="col border rounded bg-info">Awaiting bids...</div>
    </div>
    <div class="row p-1" v-if="msg">
      <div class="col bg-info rounded border">
        {{ msg }}
      </div>
    </div>
    <div
      class="row p-2"
      v-if="!msg && purchased_from_this_pool < pool_count_allowed"
    >
      <div
        class="col d-flex justify-content-around"
        v-if="last_bid.team_id != store.bidding_team_id"
      >
        <div v-for="i in auction.increment_count" :key="i">
          <button
            class="btn btn-primary btn-sm"
            v-if="last_bid.amount + auction.bid_increment * i <= store.max_bid"
            @click="submitBid(last_bid.amount + auction.bid_increment * i)"
          >
            {{
              formatToIndianCurrency(
                last_bid.amount + auction.bid_increment * i
              )
            }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col border rounded bg-warning"
        v-if="purchased_from_this_pool >= pool_count_allowed"
      >
        Pool quota completed!
      </div>
    </div>
    <div class="row p-2" v-if="expand_bids">
      <div class="col">
        <ul class="list-group">
          <li
            class="list-group-item padding2"
            v-for="b in sorted_bids"
            :key="b.id"
          >
            <div class="row d-flex align-items-center midtxt">
              <div class="col">
                <LogoSmall :path="getPath(b.team_id)"></LogoSmall>
              </div>
              <div class="col text-start">
                <TeamName :team_id="b.team_id"></TeamName>
              </div>
              <div class="col text-end">
                {{ formatToIndianCurrency(b.amount) }}
              </div>
              <div class="col text-muted text-end tinytxt">
                {{ timeAgo(b.created_at) }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import { onMounted, ref, defineProps, computed, watchEffect } from "vue";
import TeamName from "./TeamName.vue";
import LogoSmall from "../logos/LogoSmall.vue";
import LogoLarge from "../logos/LogoLarge.vue";
import supabase from "@/supabase/config";
const props = defineProps(["player_id"]);
const auction = ref({});
const player_bids = ref([]);
const expand_bids = ref(false);
const team_icon_list = ref([]);
const store = useStore();
const show_buttons = ref(false);
const force_rerender = ref(true);
const msg = ref("");
const purchased_players = ref([]);
const bidding_pool = ref({}); //to check pool count conditions
const bidding_team = ref({});
const pool_id = ref("");
const last_bid = computed(() => {
  var returnObj = { team_id: null, amount: 0 };
  var arr = [];
  player_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  if (sorted_arr.length) {
    returnObj = {
      team_id: sorted_arr[0].team_id,
      amount: sorted_arr[0].amount,
    };
  }
  return returnObj;
});

onMounted(() => {
  fetchPlayerBids();
  fetchAuction();
  fetchTeamLogoList();
  //fetchPurchasedPlayers(); // for checking if buttons can be shows
  //fetchPool();
  setTimeout(() => {
    show_buttons.value = true;
  }, 2000);
});
const fetchPool = async () => {
  //console.log("fetch pool for =>", props.player_id);
  if (props.player_id) {
    let { data: players, error } = await supabase
      .from("players")
      .select("*")
      .eq("id", props.player_id);
    //console.log(players);
    pool_id.value = players[0].pool_id;
    setTimeout(async () => {
      //console.log("fetching pool here");
      let { data: pools, error_ } = await supabase
        .from("pools")
        .select("*")
        .eq("id", pool_id.value);
      // console.log(pools);
      bidding_pool.value = pools[0];
    }, 1000);
  }
};
const fetchPurchasedPlayers = async () => {
  // console.log("fetching players with team_id=>", store.bidding_team_id);
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("team_id", store.bidding_team_id);
  purchased_players.value = players;
};
const sorted_bids = computed(() => {
  var arr = [];
  player_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  //last_bid_amount.value = sorted_arr[0].amount + auction.bid_increment;
  return sorted_arr;
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
const fetchPlayerBids = async () => {
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("player_id", props.player_id);
  player_bids.value = bids;
  setupBidsListner();
  setupDeleteListner();
};
const setupBidsListner = () => {
  const channels = supabase
    .channel("player-bids-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "bids",
        filter: `player_id=eq.${props.player_id}`,
      },
      (payload) => {
        player_bids.value = [];
        fetchPlayerBids();
      }
    )
    .subscribe();
};
const setupDeleteListner = () => {
  const channels = supabase
    .channel("player-bids-delete-channel")
    .on(
      "postgres_changes",
      { event: "DELETE", schema: "public", table: "bids" },
      (payload) => {
        var del_id = payload.old.id;
        player_bids.value = player_bids.value.filter(
          (bid) => bid.id !== del_id
        );
        force_rerender.value = false; //this is done to force a rerender of the last bid
        msg.value = "Updating bids...";
        setTimeout(() => {
          force_rerender.value = true;
          msg.value = "";
        }, 1000);
      }
    )
    .subscribe();
};
const submitBid = async (amt) => {
  expand_bids.value = false; //close bids list if its open
  const bidObj = {
    auction_id: store.live_auction,
    player_id: props.player_id,
    team_id: store.bidding_team_id,
    amount: amt,
  };
  //bidObj.amount = 1000;
  const { data, error } = await supabase.from("bids").insert([bidObj]).select();
  if (!error) {
    msg.value = "Submitting bid...";
    setTimeout(() => {
      msg.value = msg.value + "done!";
    }, 1000);
  } else {
    //duplicate key value violates unique constraint "unique_player_id_amount"
    if (
      error.message ==
      'duplicate key value violates unique constraint "unique_player_id_amount"'
    ) {
      msg.value = "Please submit a higher bid.";
    } else {
      msg.value = error.message;
    }
  }
  setTimeout(() => {
    msg.value = "";
  }, 2000);
};
const toggleExpandBids = () => {
  expand_bids.value = !expand_bids.value;
};
function timeAgo(timestamp) {
  const createdTime = new Date(timestamp);
  const now = new Date();
  const diffInSeconds = Math.floor((now - createdTime) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} seconds ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minutes ago`;
  }

  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;
  return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${
    minutes !== 1 ? "s" : ""
  } ago`;
}
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
const fetchTeamLogoList = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("id, icon")
    .eq("auction_id", store.live_auction);
  team_icon_list.value = teams;
};
const getPath = (id) => {
  var path = "";
  team_icon_list.value.forEach((i) => {
    if (i.id == id) {
      path = i.icon;
    }
  });
  return path;
};
const fetchTeamData = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("id", store.bidding_team_id);
  bidding_team.value = teams[0];
};
watchEffect(() => {
  if (store.bidding_team_id) {
    fetchPurchasedPlayers();
    fetchTeamData();
    fetchPool();
  }
});
const purchased_from_this_pool = computed(() => {
  var count = 0;
  purchased_players.value.forEach((p) => {
    if (p.pool_id == pool_id.value) {
      count++;
    }
  });
  return count;
});
const pool_count_allowed = computed(() => {
  var count = 0;
  count = bidding_pool.value.count;
  return count;
});
</script>
<style scoped>
.tinytxt {
  font-size: 8px;
}
.midtxt {
  font-size: 14px;
}
.padding2 {
  padding: 2px;
}
</style>
